import React, { useContext } from 'react'
import {
  Dropdown,
  Image,
  Menu,
  Grid,
  Icon
} from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { AppContext } from './../providers'

const BeeMenu = ({ pathname }) => {
  const { theme } = useContext(AppContext)
  return (
    <Grid verticalAlign='middle'>
      <Grid.Row>
        <Grid.Column width={3}>
          <Image as={Link} to={'/'} size='medium' src={theme.logo} />
        </Grid.Column>
        <Grid.Column width={13}>
          <Menu >
            <Menu.Item as={Link} to={'/templates'}><Icon name='edit' /> Template Catalog</Menu.Item>
            <Menu.Item as={Link} to={'/emails'}><Icon name='mail' /> My Emails</Menu.Item>
            <Menu.Item as={Link} to={'/pages'}><Icon name='html5' /> My Pages</Menu.Item>
            <Menu.Item as={Link} to={'/popups'}><Icon name='html5' /> My Popups</Menu.Item>
            <Menu.Menu position="right">
              <Dropdown item icon='setting'>
                <Dropdown.Menu>
                  <Dropdown.Item as={Link} to={'/manage-rows'} icon='th list' text='Manage Saved Rows' />
                  <Dropdown.Item as={Link} to={'/manage-settings'} icon='settings' text='Editor Settings' />
                  <Dropdown.Item as={Link} to={'/manage-themes'} icon='paint brush' text='Theme Settings' />
                </Dropdown.Menu>
              </Dropdown>
            </Menu.Menu>
          </Menu>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}
export default BeeMenu
